import $ from 'jquery';
// script only valid for if e-calendar cta inside the clicable card 
setTimeout(function(){
$(document).ready(function(){
    $(".ws-add-ecal").on("click", function(e){
      e.preventDefault();             
    });
  });

}, 1000);


// WEBPACK FOOTER //
// ./components/ws-ecalender/ws-ecalender.js